import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { PermissionService } from '../../core/services/common/permission.service';
import { FieldPermissionStyleService } from '../services/field-permission-style.service';
import { BaseFieldPermissionDirective } from './base-field-permission.directive';

@Directive({
  selector: '[appViewOnlyFieldPermission]'
})
export class ViewOnlyFieldPermissionDirective extends BaseFieldPermissionDirective implements OnInit {
  @Input() appViewOnlyFieldPermission: string = '';
  
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    permissionService: PermissionService,
    styleService: FieldPermissionStyleService
  ) {
    super(permissionService, styleService);
  }
  
  ngOnInit(): void {
    // Ignorar verificações para administradores
    if (this.permissionService.isAdminRole()) {
      return;
    }
    
    // Verificar apenas a permissão de visualização
    const { canView } = this.checkFieldPermission(this.appViewOnlyFieldPermission);
    
    // Se não pode visualizar, aplicar ofuscação
    if (!canView) {
      this.applyObfuscatedStyle();
    }
  }
  private applyObfuscatedStyle(): void {
    try {
      const element = this.el.nativeElement;
      this.styleService.applyObfuscatedStyle(element, this.renderer);
    } catch (error) {
    }
  }
}
